import firebase from 'firebase/app';
import moment from 'moment';

//blueprint
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "copied-content",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Message Copied", intent: Intent.SUCCESS, timeout: 1000});
}

export const copyToClipboard = (content, fbProfile , id, vProp, int, msgType, firstCopy, profile, auth) =>{
    var textField= document.createElement('textarea')
    textField.innerHTML=content
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    showToast()

    firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('prospects')
        .doc(id)
        .update({
            Prospected: 'Yes',
            MessageApproved: 'Yes',
            ContentCopied: content,
            InterestUsed: int,
            ProspectContentType: msgType ? msgType : '',
            ProspectVpropUsed: vProp,
            ProspectContent: content,
            firstCopy: 1 + firstCopy?.length,
            theEndOfWeek: moment().endOf('week').toDate()
        })

    firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('dailyCopied')
    .doc()
    .set({
        CreatedBy: fbProfile.email,
        Company: fbProfile.company,
        ProspectName: profile.full_name ? profile.full_name : (profile.ProspectName ? profile.ProspectName : ""),
        ProspectCompany: (profile.experiences?.length > 0) ? profile.experiences[0].company : '',
        ProspectRole: profile.occupation ? profile.occupation : '',
        ProspectInterest: int,
        ProspectContent: content,
        ProspectValuePropUsed: vProp,
        contactImg: profile.profile_pic_url ? profile.profile_pic_url : (profile.contactImg ? profile.contactImg : "") ,
        contactHeadline: profile.headline ? profile.headline : (profile.ProspectRole ? profile.ProspectRole : ""), 
        contactCity: profile.city ? profile.city : (profile.contactCity ? profile.contactCity : ""),
        contactSummary: profile?.summary ? profile.summary : '',
        createdAt: new Date(),
        AuthorID: auth.uid,
        AuthorFirstName: fbProfile.firstName,
        AuthorLastName: fbProfile.lastName,
    })
}